import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Discipline } from '@centers/interfaces/discipline';
import { Observable } from 'rxjs';

@Component({
  name: 'bpc-discipline-single',
})
export default class DisciplineSingle extends Vue {
  @Prop(String) readonly alias: string;

  public loading: boolean = false;
  public disciplineSubscription = null;
  public discipline: Discipline = null;

  created() {
    if (this.alias) {
      this.getEntity();
    }
  }

  public getEntity(): void {
    this.loading = true;

    if (this.disciplineSubscription) {
      this.disciplineSubscription.unsubscribe();
    }

    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath(
      'discipline',
      'raw',
    )}/details/${this.alias}`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(
      fetchEntityPath,
      {},
      'public',
    );

    this.disciplineSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.discipline = res.data;
      },
      error => {
        this.loading = false;
        console.log(error);
      },
      () => {
        this.loading = false;
      },
    );
  }

  @Watch('alias')
  onChangeAlias() {
    this.getEntity();
  }
}
